.modalHeader {
	@apply
	yst-pb-4
	yst-border-b
	yst-border-b-slate-200
	-yst-mx-6
	yst-px-6;
}

.modalContent {
	@apply yst-overflow-auto yst-py-6;

	/* Show scrollbar on webkit browsers */
	&::-webkit-scrollbar {
		@apply yst-w-2;
	}

	&::-webkit-scrollbar-track {
		@apply yst-bg-gray-100;
	}

	&::-webkit-scrollbar-thumb {
		@apply yst-bg-gray-400 yst-rounded;
	}

	&::-webkit-scrollbar-thumb:hover {
		@apply yst-bg-gray-600;
	}
}

.upgradeTool {
	@apply yst-space-y-6;
}

.section {
	@apply yst-space-y-1;
}


.upgradePriceBadge span {
	@apply yst-font-semibold yst-text-sm;
}

.currentSubscription {
	@apply yst-mb-8;
}

.checkmarkList {
	div {
		@apply yst-flex yst-items-center;
	}

	svg {
		@apply yst-fill-green-500 yst-h-3.5 yst-w-3.5 yst-mr-2;
	}
}

.nextRenewalPrice {
	@apply yst-flex yst-relative yst-items-center;
}

.priceAnnotation {
	@apply yst-text-[10px];
}

.requiredCheckmarks {
	> * {
		@apply yst-my-4;
	}
}

.modalFooter {
	@apply yst-pt-4 yst-border-t yst-border-gray-200 -yst-mx-6 yst-px-6;
}

.actionButtonsContainer {
	@apply
	yst-flex
	yst-items-center
	yst-justify-end
	yst-gap-3;
}

.toggleWrapper {
	@apply
	yst-flex
	yst-items-center
	yst-gap-3;
}
